import { WalletReadyState } from '@solana/wallet-adapter-base'
import type { Adapter } from '@solana/wallet-adapter-base'

export interface SolanaConnectorProvider {
  id: string
  name: string
  /** Name the wallet registers under (Wallet Standard / wallet-adapter). */
  walletName: string
  /** Where to get the wallet when it is not installed. */
  installUrl: string
}

/** Solana wallets the app offers by name for linking and connecting (FE-306). */
export const getSolanaConnectorProviders = (): SolanaConnectorProvider[] => [
  {
    id: 'phantom',
    name: 'Phantom',
    walletName: 'Phantom',
    installUrl: 'https://phantom.com/download'
  },
  {
    id: 'solflare',
    name: 'Solflare',
    walletName: 'Solflare',
    installUrl: 'https://solflare.com/download'
  },
  {
    id: 'backpack',
    name: 'Backpack',
    walletName: 'Backpack',
    installUrl: 'https://backpack.app/downloads'
  }
]

type AdapterEntry = { adapter: Adapter; readyState: WalletReadyState }

/** The wallet-adapter entry of a provider; Wallet Standard wallets appear only once installed. */
export const findProviderWallet = (
  wallets: readonly AdapterEntry[],
  provider: SolanaConnectorProvider
) => wallets.find(entry => entry.adapter.name === provider.walletName)

export const isProviderInstalled = (
  wallets: readonly AdapterEntry[],
  provider: SolanaConnectorProvider
) =>
  findProviderWallet(wallets, provider)?.readyState ===
  WalletReadyState.Installed

/** Providers that can be connected right now; Phantom always, so a missing extension gets its own error. */
export const getAvailableConnectorProviders = (
  wallets: readonly AdapterEntry[]
) =>
  getSolanaConnectorProviders().filter(
    provider =>
      provider.id === 'phantom' || isProviderInstalled(wallets, provider)
  )
